<template>
    <div>
        <div class="mb-3">
            <h5><i class="el-icon-aim text-primary mr-2"></i><i>Input number of image threshold will be expanded</i></h5>
        </div>
        <div class="d-flex align-items-center">
            <div class="mr-2">
                <h5 class="mb-0"><i class="el-icon-monitor text-primary mr-2"></i>Allow image threshold up to</h5>
            </div>
            <div>
                <el-input-number v-model="numberImageThreshold" controls-position="right" 
                                 :disabled="!enabledInput"
                                 @change="handleChange" :min="1" :max="9999"></el-input-number>
            </div>
            <div class="ml-2">
                <h5 class="mb-0">images </h5>
            </div>
        </div>
        <div class="mt-2">
            <el-checkbox v-model="enabledInput"><span style="font-weight: normal;">Allow modify value</span></el-checkbox>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            element: {
                type: Object,
                default() {
                    return null;
                },
            },
            value: {
                type: String,
                default() {
                    return 1;
                },
            },
        },
        watch: {
            element() {
                this.numberImageThreshold = parseInt(this.element.serviceDetails);
                if (this.numberImageThreshold > 0) this.$emit('input', this.numberImageThreshold.toString());
                else this.$emit('input', null);
            },
            numberImageThreshold(){
                if (this.numberImageThreshold > 0) this.$emit('input', this.numberImageThreshold.toString());
                else this.$emit('input', null);
            },
        },
        data() {
            return {
                numberImageThreshold: 1,
                enabledInput : false,
            };
        },
        created() {
            this.numberImageThreshold = parseInt(this.element.serviceDetails);
        },
        methods: {
            handleChange(value) {
                console.log(value);
                if (this.numberImageThreshold > 0) this.$emit('input', this.numberImageThreshold.toString());
                else this.$emit('input', null);
            }
        }
    };
</script>